import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, ref } from 'vue'
import localforage from 'localforage'
import { emitter } from '@/plugins/emitter'
import TopFormatBlocks from '@/components/top/TopFormatBlocks.vue'

type RecentEdit = {
  FormatId: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TopNew',
  setup(__props) {

const RECENT_EDIT_SAVE_KEY = 'recentEdit'

const isNotMidnight = ref(true)
const recentEdit = ref<RecentEdit>({
  FormatId: ''
})

function reload(): void {
  location.reload()
}

async function loadRecentEdit(): Promise<void> {
  try {
    const data = await localforage.getItem<RecentEdit>(RECENT_EDIT_SAVE_KEY)
    if (data) {
      recentEdit.value = data
    }
  } catch (err) {
    console.log(err)
  }
}

function updateRecentEdit(data: RecentEdit): void {
  if (data) {
    recentEdit.value = data
  }
}

onMounted(async () => {
  await loadRecentEdit()
  const hour = new Date().getHours()
  if (hour >= 0 && hour < 6) {
    isNotMidnight.value = false
  }
  emitter.on('change-recent-edit', updateRecentEdit)
  emitter.on('reload', reload)
})

onBeforeUnmount(() => {
  emitter.off('change-recent-edit', updateRecentEdit)
  emitter.off('reload', reload)
})

return { __sfc: true,RECENT_EDIT_SAVE_KEY, isNotMidnight, recentEdit, reload, loadRecentEdit, updateRecentEdit, TopFormatBlocks }
}

})